import { jwtDecode } from "jwt-decode";

export const getLoggedInUser = () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) return null;

    const decoded = jwtDecode(token);
    return decoded; // contains roleName, userId, etc
  } catch (error) {
    console.error("Invalid token", error);
    return null;
  }
};


export const isSuperAdmin = () =>
  getLoggedInUser()?.role === "SA";

export const isAdmin = () =>
  getLoggedInUser()?.role === "A";

export const isDoctor = () =>
  getLoggedInUser()?.role === "D";
